module.exports = __webpack_public_path__ + "img/6.1.d69ac152.png";